import { useCallback, useEffect, useRef, useState } from 'react';

export const EMPTY_CONTENT_FILTERS = {
  searchTerm: '', searchField: 'all', startDate: '', endDate: '', sortBy: 'Date Desc'
};

export const readContentPage = (response) => {
  if (response?.isSuccess === false) throw new Error(response.resultMessage || 'Kayıtlar yüklenemedi.');
  const page = Array.isArray(response?.items) ? response : response?.data;
  if (!Array.isArray(page?.items)) throw new Error('Kayıtlar yüklenemedi.');
  return { items: page.items, totalCount: Number(page.totalCount ?? page.total ?? page.items.length) };
};

export default function useContentList(loader) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState(EMPTY_CONTENT_FILTERS);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [totalCount, setTotalCount] = useState(0);
  const requestId = useRef(0);

  const reload = useCallback(async () => {
    const id = ++requestId.current;
    setLoading(true);
    setError(null);
    try {
      const response = await loader({ ...filters, searchTerm: filters.searchTerm.trim(),
        startDate: filters.startDate || null, endDate: filters.endDate || null,
        pageNum: page, pageSize });
      if (id !== requestId.current) return;
      const result = readContentPage(response);
      const lastPage = Math.max(1, Math.ceil(result.totalCount / pageSize));
      if (page > lastPage) { setPage(lastPage); return; }
      setItems(result.items);
      setTotalCount(result.totalCount);
    } catch (err) {
      if (id !== requestId.current) return;
      setError(err.message || 'Kayıtlar yüklenirken bir hata oluştu.');
      setItems([]);
      setTotalCount(0);
    } finally {
      if (id === requestId.current) setLoading(false);
    }
  }, [loader, filters, page, pageSize]);

  useEffect(() => {
    reload();
    return () => { requestId.current += 1; };
  }, [reload]);

  const apply = useCallback((next) => { setPage(1); setFilters({ ...next, searchField: 'all' }); }, []);
  return { items, setItems, loading, setLoading, error, setError, reload,
    filterProps: { filters, onApply: apply, loading, totalCount },
    paginationProps: { page, pageSize, totalCount, loading, onPageChange: setPage,
      onPageSizeChange: (size) => { setPage(1); setPageSize(size); } }
  };
}
